import type { SpinResponse } from "@slot/client-engine";
import { MergeRoundBuilder } from "../../MergeRoundBuilder";
import { OFFLINE_ROUND } from "../offlineRound";
import { FREE_SPIN_SCRIPTS } from "./freeSpinScripts";

/**
 * The trigger a chain makes itself, on the left of the board: two FS sit at the top and on the right while a 2×2 L4
 * makes two H1, which meet the two H1 falling from above and merge into the third FS (the H1 exception) — the dead
 * board's three FS win the eight free spins. The base spin pays 0.50 + 6.40 (×8) = 6.90; the session 30.50
 * (`FREE_SPIN_SCRIPTS`); the round 37.40.
 */
export function fsMergeTrigger(): SpinResponse {
  return new MergeRoundBuilder({ roundId: "merge-fs-trigger", ...OFFLINE_ROUND })
    .baseSpin(
      {
        board: [
          ["L2", "L3", "L1", "L4", "FS", "L2"],
          ["H1", "H1", "L2", "L3", "L1", "L3"],
          ["L4", "L4", "L3", "L1", "L2", "L1"],
          ["L4", "L4", "H3", "L2", "L3", "L4"],
          ["L1", "L3", "L2", "H2", "L1", "FS"],
          ["L3", "L2", "L1", "L3", "L4", "L2"],
        ],
        refill: [["H2", "L4"], ["H4", "L1", "L3"], [], [], [], []],
      },
      { freeSpins: { featureIdentifier: "free_spins", spins: FREE_SPIN_SCRIPTS } },
    )
    .build();
}
